
$(document).ready(function () {
    $('.widget-tags').each(function(i, obj) {
        let widgetId = 'widget-tags-' + i.toString();
        if (!document.getElementById(widgetId)) {
            $(this).attr('id', widgetId);
            $(this).find('.more').attr('id', widgetId + '-more');
        }
        $(document).on('click', '#' + widgetId + ' .tags-main-block .more', function () {
            let id = $(this).attr('id').replace('-more', '');
            $('#' + id + ' .tags-main-block').html(
                $('#' + id + ' .tags-main-block').html() + $('#' + id + ' .slideblock').html()
            );
            $('#' + id + ' .tags-main-block .more').hide();
            $('#' + widgetId + ' .tags-main-block .hide-more').on('click', function () {
                $('#' + id + ' .tags-main-block .additional').remove();
                $('#' + id + ' .tags-main-block .more').show();
            });
        });
    });
});
